<ion-header [translucent]="true" title="Dashboard">
  <ion-toolbar color="success">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Fauna</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <ion-tabs>
    <ion-tab-bar slot="bottom">
      <ion-tab-button tab="/dashboard">
        <ion-icon name="play-circle"></ion-icon>
        Listen Now
      </ion-tab-button>
      <ion-tab-button tab="radio">
        <ion-icon name="radio"></ion-icon>
        Radio
      </ion-tab-button>
      <ion-tab-button tab="library">
        <ion-icon name="library"></ion-icon>
        Library
      </ion-tab-button>
      <ion-tab-button tab="search">
        <ion-icon name="search"></ion-icon>
        Search
      </ion-tab-button>



    </ion-tab-bar>
  </ion-tabs>
</ion-content>
<app-rodape [exibirBotoes]="false"/>
